<template>
  <div class="page">
    <div v-if="loading == true" class="page-loader">
      <LoadingRoller />
    </div>
    <div v-if="loading == false">
      <section class="page-toolbar" aria-label="أدوات العرض">
        <div class="page-toolbar__row">
          <!--<b-form-datepicker id="example-datepicker" v-model="date" @input="onDateChange"></b-form-datepicker>-->
          <b-button v-if="currentUserId != 0" variant="primary" class="app-btn" @click="goToVisits()">المبيعات</b-button>
        </div>
        <!--<DayChips :chip="chip" :selection.sync="selection" @select="selectDay" />-->
      </section>

      <div v-if="loading == false && tickets.length == 0" class="empty-state">
        <v-icon size="48" color="primary">mdi-calendar-blank-outline</v-icon>
        <p class="empty-state__text">لا يوجد جلسات مبيعات عند التاريخ المحدد</p>
      </div>

      <div class="card-grid">                
        <div class="card-grid__item" v-for="(t, i) in tickets" :key="i">
          <v-card :class="['visit-card', { 'visit-card--answered': isAnswered(t) }]">
            <VisitCardTitle :client-name="t.ClientName" :branch-name="t.Governorate" :region="t.Region" :address="t.Address" />
            <div class="visit-card__body">
              <PhoneLinks v-if="t.Numberphone != null && t.Numberphone != ''" :phone="t.Numberphone" />
              <p class="visit-card__line_green">
                <span class="visit-card__label">الموظف</span>
                {{ t.DisplayName }}
              </p>              
            </div>
            <p v-if="formatDateTimeAr(t.TimeStamp)" class="visit-card__date">
              <v-icon small>mdi-clock-outline</v-icon>
              <time :datetime="t.TimeStamp">{{ formatDateTimeAr(t.TimeStamp) }}</time>              
            </p>

            <!-- An answered session shows only its title until "إظهار التفاصيل" is pressed. -->
            <div v-if="isAnswered(t)" class="visit-card__status">
              <span class="visit-card__badge">
                <v-icon small color="success">mdi-check-circle</v-icon>
                تمت الإجابة
              </span>
              <v-btn text small color="primary" :aria-expanded="String(isExpanded(t))" @click="toggleDetails(t)">
                {{ isExpanded(t) ? "إخفاء التفاصيل" : "إظهار التفاصيل" }}
                <v-icon small>{{ isExpanded(t) ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
              </v-btn>
            </div>

            <template v-if="!isAnswered(t) || isExpanded(t)">
            <v-divider></v-divider>
            

            <div class="visit-card__section">
              <fieldset class="question">
                <legend class="question__title">هل الشركة موجودة ؟</legend>
                <div class="choice-group">
                  <label class="choice"><input type="radio" :name="'closed-' + i" :value="false" v-model="t.IsClosed" />نعم</label>
                  <label class="choice"><input type="radio" :name="'closed-' + i" :value="true" v-model="t.IsClosed" />لا</label>
                </div>
              </fieldset>

              <fieldset v-if="t.IsClosed == false" class="question">
                <legend class="question__title">هل ما زال يستخدم برامج الشركة ؟</legend>
                <div class="choice-group">
                  <label class="choice"><input type="radio" :name="'used-' + i" :value="true" v-model="t.IsUsedPrograming" />نعم</label>
                  <label class="choice"><input type="radio" :name="'used-' + i" :value="false" v-model="t.IsUsedPrograming" />لا</label>
                </div>
              </fieldset>

              <template v-if="programs.length>0 && t.IsClosed == false && t.IsUsedPrograming == true">                
                
                <!-- Questions not tied to a program (programId 0). -->
                <div v-if="questionsOf(0).length > 0" class="question-group">
                  <span class="question-group__label">أسئلة عامة</span>
                  <fieldset v-for="(q, j) in questionsOf(0)" :key="q.id" class="question">
                    <legend class="question__title">
                      <span class="question__number">{{ j + 1 }}</span>
                      {{ q.question }}
                    </legend>
                    <!-- One radio group per card, program and question (shared name), so picking an option clears the others. -->
                    <div class="choice-group">
                      <label v-for="o in q.options" :key="o.id" class="choice">
                        <input
                          :type="q.typeSelection == 'False' ? 'radio' : 'checkbox'"
                          :name="'q-' + i + '-' + 0 + '-' + j"
                          :value="o.id"
                          :checked="getAnswer(t, 0, q, o.id)"
                          @change="setAnswer(t, 0, q, o.id, $event.target.checked)"
                        />
                        {{ o.optionTitle }}
                      </label>
                      <AddOption v-if="canAddOption(q)" :save="(title) => addOption(t, 0, q, title)" />
                    </div>
                  </fieldset>
                </div>

                <fieldset class="question">
                  <legend class="question__title">ماهي البرامج المستخدمة ؟</legend>
                  <!-- Several programs can be checked; the checked ProgramIds are kept in t.UsedPrograms. -->
                  <div class="choice-group">
                    <label v-for="cp in programs" :key="cp.Id" class="choice">
                      <input type="checkbox" :name="'programs-' + i" :value="cp.Id" v-model="t.UsedPrograms" />
                      {{ cp.Name }}
                    </label>
                  </div>
                </fieldset>

                <!-- The questions are asked again for every checked program; the answers are kept per program. -->
                <!-- Each checked program gets its own panel holding its questions, so they read as belonging to it. -->
                <section v-for="p in selectedPrograms(t)" :key="'p-' + p.Id" class="program-block"
                  :aria-label="'أسئلة برنامج ' + p.Name">
                  <header class="program-block__header">
                    <v-icon small color="primary">mdi-application-outline</v-icon>
                    <span class="program-block__name">{{ p.Name }}</span>
                  </header>

                  <div class="program-block__body">
                    <fieldset v-for="(q, j) in questionsOf(p.Id)" :key="q.id" class="question">
                      <legend class="question__title">
                        <span class="question__number">{{ j + 1 }}</span>
                        {{ q.question }}
                      </legend>
                      <!-- One radio group per card, program and question (shared name), so picking an option clears the others. -->
                      <div class="choice-group">
                        <label v-for="o in q.options" :key="o.id" class="choice">
                          <input
                            :type="q.typeSelection == 'False' ? 'radio' : 'checkbox'"
                            :name="'q-' + i + '-' + p.Id + '-' + j"
                            :value="o.id"
                            :checked="getAnswer(t, p.Id, q, o.id)"
                            @change="setAnswer(t, p.Id, q, o.id, $event.target.checked)"
                          />
                          {{ o.optionTitle }}
                        </label>
                        <AddOption v-if="canAddOption(q)" :save="(title) => addOption(t, p.Id, q, title)" />
                      </div>
                    </fieldset>
                    <p v-if="questionsOf(p.Id).length == 0" class="program-block__empty">لا توجد أسئلة لهذا البرنامج</p>
                  </div>
                </section>

                <!--<template v-if="t.clientPrograms.length > 0">
                  <span class="section-label">مدى رضى الزبون عن أداء برامجه ؟</span>
                  <div v-for="(cp, i2) in t.clientPrograms" :key="i2">
                    <span class="visit-card__line">{{ cp.ProgramName }}</span>
                    <v-rating
                      v-model="cp.CustomerSatisfaction"
                      color="warning"
                      background-color="grey lighten-1"
                      hover
                    ></v-rating>
                  </div>
                </template>-->

                <v-textarea outlined hide-details="auto" label="التفاصيل" name="details" v-model="t.Details"
                  :rules="[$rules.required()]"></v-textarea>
              </template>
              <template v-if="programs.length>0 && t.IsClosed == false && t.IsUsedPrograming == false">
                <fieldset class="question">
                  <legend class="question__title">ماهي البرامج المستخدمة  ؟</legend>
                  <v-textarea outlined auto-grow rows="2" hide-details="auto" name="other-programs"
                    placeholder="أسماء البرامج التي يستخدمها الزبون حالياً" v-model="t.OtherPrograms"></v-textarea>
                </fieldset>
                <fieldset class="question">
                  <legend class="question__title">مالسبب ب استبدال برامجنا ؟</legend>
                  <v-textarea outlined auto-grow rows="2" hide-details="auto" name="replacement-reason"
                    placeholder="سبب انتقال الزبون إلى برامج أخرى" v-model="t.ReplacementReason"></v-textarea>
                </fieldset>
              </template>
            </div>

            <div class="visit-card__footer">
              <v-btn @click="updateVisitSalesmen(t)" block large depressed color="primary">تم</v-btn>
            </div>
            </template>
          </v-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import DayChips from "@/components/DayChips.vue";
import LoadingRoller from "@/components/LoadingRoller.vue";
import PhoneLinks from "@/components/PhoneLinks.vue";
import VisitCardTitle from "./VisitCardTitle.vue";
import AddOption from "./AddOption.vue";
import { encryptText } from "@/utils/crypto";
import { daysFromToday, formatDateISO, formatDateTimeAr, getDateChip } from "@/utils/date";

/** Query params of the read requests of this screen (the API expects them encrypted). */
const buildParams = (date) => ({
  date: encryptText(date),
  id: encryptText(localStorage.getItem("userData")),
  tocken: encryptText(Date.now().toString()),
});

/** Reads a saved object that may arrive as JSON text; anything else than an object gives {}. */
const asObject = (raw) => {
  let value = raw;
  if (typeof value == "string") {
    try {
      value = JSON.parse(value);
    } catch (e) {
      value = null;
    }
  }
  return value && typeof value == "object" ? value : {};
};

const toId = (id) => (isNaN(id) ? id : Number(id));

/** Most options a question can have; past it no option can be added. */
const MAX_OPTIONS = 20;

/**
 * Turns the saved answers of one program into question id -> list of option ids (numbers). A single saved option id
 * (answers saved before they were lists) becomes a list of one.
 */
const parseProgramAnswers = (raw) => {
  const saved = asObject(raw);
  const answers = {};
  Object.keys(saved).forEach((IdQuestion) => {
    const optionIds = [].concat(saved[IdQuestion]).filter((id) => id != null && id !== "");
    if (optionIds.length > 0) answers[IdQuestion] = optionIds.map(toId);
  });
  return answers;
};

/**
 * Gives each session its own `answers`: program id -> (question id -> list of chosen option ids), filled from the answers
 * saved with it so the chosen options show checked, and `UsedPrograms`: the program ids checked in
 * "ماهي البرامج المستخدمة" (saved ones too). Added before Vue makes them reactive.
 */
const withAnswers = (sessions) =>
  sessions.map((s) => {
    const saved = asObject(s.answers || s.Answers);
    const answers = {};
    Object.keys(saved).forEach((programId) => {
      answers[programId] = parseProgramAnswers(saved[programId]);
    });
    const UsedPrograms = Array.isArray(s.UsedPrograms) ? s.UsedPrograms.map((id) => (isNaN(id) ? id : Number(id))) : [];
    // OtherPrograms / ReplacementReason: answers to the questions asked when the client no longer uses our programs.
    return { ...s, answers, UsedPrograms, OtherPrograms: s.OtherPrograms || "", ReplacementReason: s.ReplacementReason || "" };
  });

const LOCATION_ERRORS = {
  1: "يرجى السماح بالوصول إلى الموقع ثم المحاولة مجددا",
  2: "تعذر تحديد الموقع، يرجى تشغيل خدمة الموقع (GPS)",
  3: "انتهت مهلة تحديد الموقع، يرجى المحاولة مجددا",
};

/** Resolves with the device's current location (any accuracy), or rejects with an Arabic message to show the user. */
const getLocation = () =>
  new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("المتصفح لايدعم تحديد الموقع"));
      return;
   }
    // Some browsers never call back while the permission prompt is open or after it is dismissed.
    const guard = setTimeout(() => reject(new Error(LOCATION_ERRORS[3])), 20000);
    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        clearTimeout(guard);
        resolve(coords);
      },
      (error) => {
        clearTimeout(guard);
        // Browsers deny the location to pages not opened over HTTPS (or localhost).
        const hint = error.code == 1 && !window.isSecureContext ? " (يتطلب فتح التطبيق عبر HTTPS)" : "";
        reject(new Error((LOCATION_ERRORS[error.code] || "تعذر تحديد الموقع") + hint));
      },
      // Low accuracy (Wi-Fi/cell) answers fast, also indoors; a location from the last minute is fine.
      { enableHighAccuracy: false, maximumAge: 60000, timeout: 15000 }
    );
  });

export default {
  name: "Salesmen",
  components: { /*DayChips,*/ AddOption, LoadingRoller, PhoneLinks, VisitCardTitle },
  data() {
    return {
      // Raw "userData" value from localStorage; the "المبيعات" button stays hidden while it is 0.
      currentUserId: 0,
      tickets: [],
      questions: [],
      // Loaded for later use: not displayed yet, but the request is part of the screen's contract.
      programs: [],
      loading: false,
      // Number of the latest load; an answer to an older one is ignored.
      lastRequest: 0,
      date: new Date(),
      chip: 0,
      // Selected index of the day chips (owned here: see DayChips). Starts empty on this screen,
      // like the original, where "selection" was never declared (no chip is highlighted until one is clicked).
      selection: undefined,
      // Ids of the answered sessions whose details are shown (answered ones start collapsed).
      expandedIds: [],
    };
  },
  created() {
    this.loadSalesmen();
  },
  methods: {
    formatDateTimeAr,
    goToVisits() {
      this.$router.push({ name: "visits" });
      localStorage.setItem("page", "visit");
    },
    /** A session is answered once its location was saved (latitude set and not 0). */
    isAnswered(ticket) {
      return ticket.latitude != null && ticket.latitude != 0;
    },
    isExpanded(ticket) {
      return this.expandedIds.includes(ticket.Id);
    },
    toggleDetails(ticket) {
      this.expandedIds = this.isExpanded(ticket)
        ? this.expandedIds.filter((id) => id != ticket.Id)
        : [...this.expandedIds, ticket.Id];
    },
    /** Closes the snackbar first so a repeated message visibly shows again instead of looking like nothing happened. */
    async showMessage(message, color = "error") {
      this.$store.commit("UPDATE_SNACKBAR", false);
      await this.$nextTick();
      this.$store.commit("UPDATE_SNACKBAR_MESSAGE", { message, color });
    },
    /** "تم": nothing is sent unless the location is obtained first; the location is saved with the visit. */
    async updateVisitSalesmen(ticket) {
      this.loading = true;
      let coords;
      try {
        coords = await getLocation();
      } catch (error) {
        this.showMessage(error.message);
        this.loading = false;
        return;
      }
      try {
        await this.$http.post("/detectLocation", {
          Id: ticket.Id,
          latitude: coords.latitude,
          longitude: coords.longitude,
        });
        // In parallel, so a slow network costs one wait instead of one per program.
        await Promise.all(
          ticket.clientPrograms.map((program) =>
            this.$http.post("/EditRatingClientProgram", {
              Id: program.Id,
              CustomerSatisfaction: program.CustomerSatisfaction,
            })
          )
        );
        await this.$http.post("/EditDetailsVisitSalesmen", {
          ClientId: ticket.ClientId,
          IsUsedPrograming: ticket.IsUsedPrograming,
          Details: ticket.Details,
          Id: ticket.Id,
          IsClosed: ticket.IsClosed,
          // Answers of programs unchecked after answering are kept on screen (re-checking restores them) but not sent.
          answers: ticket.answers/*this.selectedPrograms(ticket).reduce((answers, p) => {
            answers[p.Id] = this.getAnswersOf(ticket, p.Id);
            return answers;
          }, {})*/,
          UsedPrograms: ticket.UsedPrograms,
          OtherPrograms: ticket.OtherPrograms,
          ReplacementReason: ticket.ReplacementReason,
        });
        // Shows the card as answered (collapsed) right away, without reloading the sessions.
        this.$set(ticket, "latitude", 3.5);//coords.latitude
        this.$root.$emit("refresh-data");
      } catch (error) {
        // Failed requests are already reported by the http interceptor; anything else would fail silently.
        if (!error.isAxiosError) {
          console.error(error);
          this.showMessage(`حدث خطأ أثناء الحفظ: ${error.message}`);
        }
      } finally {
        this.loading = false;
      }
    },
    /** The programs checked in "ماهي البرامج المستخدمة", in the order of the programs list. */
    selectedPrograms(ticket) {
      return this.programs.filter((p) => ticket.UsedPrograms.some((id) => id == p.Id));
    },
    /**
     * The questions (with options) asked for `programId`; 0 gives the general questions. Must never throw: an error
     * while rendering keeps the previous render on screen, i.e. the loader stays on for good.
     */
    questionsOf(programId) {
      return this.questions.filter(
        (q) => q && Array.isArray(q.options) && (q.options.length > 0 || this.canAddOption(q)) && q.programId == programId
      );
    },
    /**
     * Questions flagged allow_add_option = 'True' let the salesman add an option of their own, until they have
     * MAX_OPTIONS options ("إضافة خيار" is then hidden).
     */
    canAddOption(question) {
      return question.allow_add_option == "True" && question.options.length < MAX_OPTIONS;
    },
    /**
     * Saves a new option of `question` on the server, adds it to the question's options (shared by every card) and
     * chooses it in this card. Rejects (keeping the field open) when the title is a duplicate or the request fails.
     */
    async addOption(ticket, programId, question, title) {
      if (question.options.length >= MAX_OPTIONS) {
        this.showMessage(`لا يمكن إضافة أكثر من ${MAX_OPTIONS} خياراً`);
        throw new Error("too many options");
      }
      const existing = question.options.find((o) => String(o.optionTitle).trim() == title);
      if (existing) {
        this.showMessage("هذا الخيار موجود مسبقاً");
        throw new Error("duplicate option");
      }
      const res = await this.$http.post("/AddQuestionOption", { IdQuestion: question.id, OptionTitle: title });
      // The server answers with a list holding the added option: [{ id, optionTitle, IdQuestion, IsDeleted }].
      const data = res.data && res.data.result !== undefined ? res.data.result : res.data;
      const option = Array.isArray(data) ? data[0] : data;
      // Added to the question shown on screen (shared by every card), then chosen in this card.
      question.options.push({ ...option, optionTitle: option.optionTitle || title });
      this.setAnswer(ticket, programId, question, option.id, true);
    },
    getAnswersOf(ticket, programId) {
      return ticket.answers[programId] || {};
    },
    /** Whether `optionId` is one of the option ids saved for `question` (always a list, whatever its typeSelection). */
    getAnswer(ticket, programId, question, optionId) {
      const answer = this.getAnswersOf(ticket, programId)[question.id];
      return Array.isArray(answer) && answer.some((id) => id == optionId);
    },
    /**
     * Saves the chosen option in the question's list of option ids: a single choice (typeSelection 'False') replaces
     * the list with just this option, a multiple choice adds / removes it. A program's answers object is created
     * (reactively) the first time it is answered.
     */
    setAnswer(ticket, programId, question, optionId, checked) {
      if (!ticket.answers[programId]) this.$set(ticket.answers, programId, {});
      const answers = ticket.answers[programId];
      if (question.typeSelection == 'False') {
        this.$set(answers, question.id, [optionId]);
        return;
      }
      const chosen = Array.isArray(answers[question.id]) ? answers[question.id].filter((id) => id != optionId) : [];
      if (checked) chosen.push(optionId);
      this.$set(answers, question.id, chosen);
    },
    selectDay(offset) {
      this.chip = offset;
      this.date = formatDateISO(daysFromToday(offset));
      this.onDateChange();
    },
    /** Date picker / chip changed: loads the sessions of `this.date`. */
    async onDateChange() {
      const request = ++this.lastRequest;
      this.loading = true;
      this.chip = getDateChip(this.date);
      this.$store.commit("setLoading", true);
      this.currentUserId = localStorage.getItem("userData");
      await this.fetchResource("/salesmen", buildParams(this.date), (result) => {
        // A slow answer for a date picked earlier must not replace the sessions of the date picked since.
        if (request == this.lastRequest) this.tickets = withAnswers(result);
      });
      if (request == this.lastRequest) this.loading = false;
    },
    /** Loads today's sessions, programs and questions (or jumps to the visits screen if that was the last one used). */
    async loadSalesmen() {
      if (localStorage.getItem("page") == "visit") {
        this.$router.push({ name: "visits" });
        return;
      }
      const request = ++this.lastRequest;
      this.loading = true;
      this.$store.commit("setLoading", true);
      this.currentUserId = localStorage.getItem("userData");
      const params = buildParams(formatDateISO());
      // In parallel: the wait is the slowest request, not the sum of the three.
      await Promise.all([
        this.fetchResource("/salesmen", params, (result) => {
          if (request != this.lastRequest) return;
          this.chip = 0;
          this.tickets = withAnswers(result);
        }),
        this.fetchResource("/programs", params, (result) => {
          this.programs = Array.isArray(result) ? result : Object.values(result);
        }),
        this.fetchResource("/questions", params, (result) => {
          // Kept as a list (questionsOf filters it), also if the API answers with an object of questions.
          this.questions = Array.isArray(result) ? result : Object.values(result);
        }),
      ]);
      if (request == this.lastRequest) this.loading = false;
    },
    /**
     * GETs `path` and hands its result to `onLoaded`. Never throws: a failed or timed-out request is already
     * reported by the http interceptor, and throwing here left the spinner on for good.
     */
    async fetchResource(path, params, onLoaded) {
      try {
        const res = await this.$http.get(path, { params });
        if (res.status == 200) onLoaded(res.data.result || []);
      } catch (error) {
        if (!error.isAxiosError) {
          console.error(error);
          this.showMessage(`تعذر عرض البيانات: ${error.message}`);
        }
      } finally {
        this.$store.commit("setLoading", false);
      }
    },
  },
};
</script>
